import { PageHeader } from '@giyus/patterns';
import { Button } from '@giyus/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/** Página NotFound local (Parte 14.5/14.7: 404 e 403 PLT_NETWORK_SCOPE_REQUIRED caem aqui). */
export function NotFoundPage() {
  const { t } = useTranslation('shell');
  return (
    <section className="flex flex-col items-start gap-5" data-testid="not-found">
      <PageHeader eyebrow="404" title={t('notFound.title')} description={t('notFound.message')} />
      <Button asChild variant="outline">
        <Link to="/">{t('notFound.backHome')}</Link>
      </Button>
    </section>
  );
}
